import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Layout from "./Layout";
import Home from "./Pages/HomePage";
import Login from "./Pages/LoginForm";
import Segnalazioni_registro from "./Pages/Segnalazioni_registro";
import Segnalazioni_nuova from "./Pages/Segnalazioni_nuova";
import ElencoCondomini from "./Pages/ElencoCondomini";
import ProduzioneDaFatturare from "./Pages/ProduzioneDaFatturare";
import RegistraConciliazioneContoCorrentePage from "./Pages/Cont_Registra_Conciliazione";
import RegistroCondominiConciliatiPage from "./Pages/Cont_Registro_Conciliazioni";

const PrivateRoute = ({ children }) => {
  const token = localStorage.getItem("token");
  if (!isTokenValid(token)) {
    localStorage.removeItem("token"); // pulizia
    return <Navigate to="/login" replace />;
  }
  return token ? children : <Navigate to="/login" replace />;
};

// auth.js
export function isTokenValid(token) {
  if (!token) return false;

  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    const now = Date.now() / 1000; // secondi
    return payload.exp && payload.exp > now;
  } catch (e) {
    return false;
  }
}

function App() {
  return (
    <div
      style={{
        minHeight: "100vh",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <Router>
        <Routes>

          <Route path="/login"
            element={
              <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh", width: "100vw" }}>
                <Login />
              </div>
            }
          />

          <Route path="/home" element={<PrivateRoute><Layout /></PrivateRoute>} >

          <Route index element={<Home />}/></Route>

          
          <Route path="/registro-segnalazioni" 
            element={<div><Layout /></div>}>
            <Route index element={<Segnalazioni_registro />}/>
          </Route>


          <Route path="/segnalazione" 
            element={<div><Layout /></div>}>
            <Route index element={<Segnalazioni_nuova />}/>
          </Route>

          <Route path="/produzione-da-fatturare"
            element={<div><Layout /></div>}>
            <Route index element={<ProduzioneDaFatturare />}/>
          </Route>  

          <Route path="/Cont_Registra_Conciliazione"
            element={<div><Layout /></div>}>
            <Route index element={<RegistraConciliazioneContoCorrentePage />}/>
          </Route>  

           <Route path="/Cont_Registro_Conciliazioni"   
           element={<div><Layout /></div>}>
            <Route index element={<RegistroCondominiConciliatiPage />}/>
          </Route>  
           
          <Route path="/condomini" 
            element={
            <div>
            <Layout />
            </div>
            }>
            <Route index element={<ElencoCondomini />} />
          </Route>
        
        
          {/*Se non trova la path lo manda su home */}
          <Route path="*" element={<Navigate to="/home" replace />} />    
      
        </Routes>
      </Router>
    </div>
  );
}

export default App;
